import axios from 'axios'
const bilimsanat = async () => {
    let response;
    var config = {
        method: 'get',
        url: process.env.REACT_APP_API_URL + '/api/v1/bilimsanatdali',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            authorization : 'bearer '+ localStorage.getItem('accessToken')
        },
    };
    await axios(config)
        .then((res) => {
            response = res;
        })
        .catch((err) => {
            console.log(err);
            response = err
        });
    return response;
};

const bilimsanatCreate = async (data) => {
    let response;
    var config = {
        method: 'post',
        url: process.env.REACT_APP_API_URL + '/api/v1/bilimsanatdali/create',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            authorization : 'bearer '+ localStorage.getItem('accessToken')
        },
        data : data
    };
    await axios(config)
        .then((res) => {
            response = res;
        })
        .catch((err) => {
            console.log(err);
            response = err
        });
    return response;
};

const bilimsanatUpdate = async (id,data) => {
    let response;
    var config = {
        method: 'put',
        url: process.env.REACT_APP_API_URL + '/api/v1/bilimsanatdali/'+id,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            authorization : 'bearer '+ localStorage.getItem('accessToken')
        },
        data : data
    };
    await axios(config)
        .then((res) => {
            response = res;
        })
        .catch((err) => {
            console.log(err);
            response = err
        });
    return response;
};


export {
    bilimsanat,
    bilimsanatCreate,
    bilimsanatUpdate
};